(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-menu-banner"] && !Shopify.designMode) return;
  try {
    
  // AJAX updates for two different triggers:
  // 1) Our own category tabs (data-cmb-tab) — swaps BOTH the banner/menu
  //    block and the product grid, via a full-page fetch + DOM parse.
  // 2) Shopify's native filter/sort widgets below — these update the URL
  //    themselves (via history.pushState/replaceState) but only refresh
  //    Shopify's own built-in section, not our custom product grid. So we
  //    watch for ANY url change and re-sync just the grid to match it.
  (function () {
    if (window.__cmbAjaxBound) return;
    window.__cmbAjaxBound = true;

    var MENU_SELECTOR = '[data-cmb-root]';
    var GRID_SELECTOR = '.ccg-section';
    var isOwnNavigation = false;

    async function fetchDoc(url) {
      var res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error('fetch failed: ' + res.status);
      var html = await res.text();
      return new DOMParser().parseFromString(html, 'text/html');
    }

    // Full swap: banner/menu + grid, used for category tab clicks.
    async function loadCategory(url) {
      isOwnNavigation = true;
      try {
        var newDoc = await fetchDoc(url);

        var currentMenu = document.querySelector(MENU_SELECTOR);
        var newMenu = newDoc.querySelector(MENU_SELECTOR);
        if (currentMenu && newMenu) {
          currentMenu.outerHTML = newMenu.outerHTML;
        }

        var currentGrid = document.querySelector(GRID_SELECTOR);
        var newGrid = newDoc.querySelector(GRID_SELECTOR);
        if (currentGrid && newGrid) {
          currentGrid.outerHTML = newGrid.outerHTML;
        }

        if (newDoc.title) document.title = newDoc.title;

        history.pushState({}, '', url);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (err) {
        console.error('[CMB] error, falling back to full navigation', err);
        window.location.href = url;
      } finally {
        isOwnNavigation = false;
      }
    }

    // Grid-only sync: used when a filter/sort widget changes the URL on its own.
    async function syncGrid(url) {
      try {
        var newDoc = await fetchDoc(url);
        var currentGrid = document.querySelector(GRID_SELECTOR);
        var newGrid = newDoc.querySelector(GRID_SELECTOR);
        if (currentGrid && newGrid) {
          currentGrid.outerHTML = newGrid.outerHTML;
        }
      } catch (err) {
        console.error('[CMB] grid sync error', err);
      }
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-cmb-tab]');
      if (!link) return;
      e.preventDefault();
      loadCategory(link.getAttribute('href'));
    });

    var origPushState = history.pushState;
    var origReplaceState = history.replaceState;

    function onUrlChanged() {
      if (isOwnNavigation) return;
      syncGrid(window.location.href);
    }

    history.pushState = function () {
      origPushState.apply(history, arguments);
      onUrlChanged();
    };
    history.replaceState = function () {
      origReplaceState.apply(history, arguments);
      onUrlChanged();
    };

    window.addEventListener('popstate', function () {
      if (isOwnNavigation) return;
      loadCategory(window.location.href);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-grid"] && !Shopify.designMode) return;
  try {
    
  // Horizon ke native "grid size" buttons (filter bar ke right side wale icons)
  // sirf Horizon ki apni product grid ko badalte hain. Ye script unhi buttons
  // ko hamari custom grid (.ccg-grid) se jorti hai.
  //   Desktop: name="grid"        -> "default" | "zoom-out"
  //   Mobile : name="grid-mobile" -> "default" | "mobile-single"
  (function () {
    if (window.__ccgViewBound) return;
    window.__ccgViewBound = true;

    var KEY_D = 'product-grid-view-desktop';
    var KEY_M = 'product-grid-view-mobile';
    var VALID_D = ['default', 'zoom-out'];
    var VALID_M = ['default', 'mobile-single'];

    function read(key, valid) {
      try {
        var v = sessionStorage.getItem(key);
        if (v && valid.indexOf(v) !== -1) return v;
      } catch (e) {}
      return 'default';
    }

    function save(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {}
    }

    var state = { d: read(KEY_D, VALID_D), m: read(KEY_M, VALID_M) };
    var mqSmall = window.matchMedia('(max-width: 749px)');

    function applyView() {
      var grids = document.querySelectorAll('.ccg-grid');
      var useSingle = mqSmall.matches && state.m === 'mobile-single';

      grids.forEach(function (grid) {
        if (grid.getAttribute('data-view-d') !== state.d) grid.setAttribute('data-view-d', state.d);
        if (grid.getAttribute('data-view-m') !== state.m) grid.setAttribute('data-view-m', state.m);

        // 1 column mobile view mein image poori width par aati hai, is liye
        // bari image mangwao (warna dhundli lagti hai).
        grid.querySelectorAll('.cc-card__image').forEach(function (img) {
          if (!img.dataset.ccgSizes) img.dataset.ccgSizes = img.getAttribute('sizes') || '';
          var want = useSingle ? '100vw' : img.dataset.ccgSizes;
          if (want && img.getAttribute('sizes') !== want) img.setAttribute('sizes', want);
        });
      });

      // Filter change ke baad Horizon radio buttons dobara default par la sakta hai,
      // un ko hamari current selection ke saath barabar rakho.
      document.querySelectorAll('input[name="grid"]').forEach(function (r) {
        var should = r.value === state.d;
        if (r.checked !== should) r.checked = should;
      });
      document.querySelectorAll('input[name="grid-mobile"]').forEach(function (r) {
        var should = r.value === state.m;
        if (r.checked !== should) r.checked = should;
      });
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || t.type !== 'radio') return;

      if (t.name === 'grid' && VALID_D.indexOf(t.value) !== -1) {
        state.d = t.value;
        save(KEY_D, t.value);
      } else if (t.name === 'grid-mobile' && VALID_M.indexOf(t.value) !== -1) {
        state.m = t.value;
        save(KEY_M, t.value);
      } else {
        return;
      }
      applyView();
    });

    // Grid AJAX se dobara banti hai (category tab / filter / sort), to view dobara lagao.
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applyView();
      });
    });

    function start() {
      applyView();
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    if (mqSmall.addEventListener) mqSmall.addEventListener('change', applyView);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
